import { HrpBaseClient } from './HrpBaseClient'

export class HrpAccountClient extends HrpBaseClient {
    constructor(
        hrpProxyApiUrl = process.env.HRP_PROXY_API_URL,
        hrpProxySecretName = process.env.HRP_PROXY_SECRET_NAME,
        axiosOptions
    ) {
        super(hrpProxyApiUrl, hrpProxySecretName, axiosOptions)
    }

    async getAccounts({
        accountKey, accountHccId, accountLevel = 0, includeSubAccounts = 'N'
    }) {
        await this.createSecureAxiosInstance()

        const searchParams = Object.entries({
            accountKey, accountHccId, accountLevel, includeSubAccounts
        })
            .filter(([_, value]) => value !== undefined)
            .reduce((obj, [key, value]) => {
                obj[key] = value;
                return obj;
            }, {});

        try {
            const response = await this.secureAxiosInstance.get(
                `/admin/api/account/db/getAccounts`, 
                {
                    params: searchParams
                }
            );

            return response.data
        } 
        catch (e) {
            throw e.response
        }
    }
}
